import { render, staticRenderFns } from "./ThemeSetting.vue?vue&type=template&id=4b849c88&scoped=true"
import script from "./ThemeSetting.vue?vue&type=script&lang=js"
export * from "./ThemeSetting.vue?vue&type=script&lang=js"
import style0 from "./ThemeSetting.vue?vue&type=style&index=0&id=4b849c88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b849c88",
  null
  
)

export default component.exports